import { render, staticRenderFns } from "./Detailsblog.vue?vue&type=template&id=9d208acc&"
import script from "./Detailsblog.vue?vue&type=script&lang=js&"
export * from "./Detailsblog.vue?vue&type=script&lang=js&"
import style0 from "./Detailsblog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports